import { DEFAULT_REFRESH_INTERVAL } from '../constants'
import { Device, WindowSize } from '../helpers'
import type WebModel from '../models/WebModel'
import { Slot } from './Slot'
import { ExperimentFlag } from '../enums/ExperimentFlag'
import { hasOutstream } from '../outstream/hasOutstream'
import { AdType } from '../enums/AdType'
import { ITimeoutMap, Timeout } from './helpers/Timeout'
import { hasNative } from '../native/hasNative'
import { AdBoxConfig, hasAdBox } from './helpers/AdBox'
import { hasInView } from './helpers/InView'
import { hasIBV } from '../ibv/hasIBV'
import { IBVConfig } from '../ibv/IBVConfig'

export const MOBILE_ADUNIT_ID = 'recipe_mobile'
export const DESKTOP_ADUNIT_ID = 'recipe_btf'

const timeouts: RecursivePartial<ITimeoutMap> = {
  desktop: {
    lazy: 2100,
    ref: 1400
  },
  mobile: {
    lazy: 2900,
    ref: 1800
  }
}
const heightPxToContain = 320
const widthStyle = '300px'

@hasIBV
@hasOutstream
@hasNative
export class Recipe extends hasInView(
  hasAdBox(Slot, heightPxToContain, widthStyle)
) {
  refreshTime = DEFAULT_REFRESH_INTERVAL
  lazy = true
  slotName = 'recipe'
  restrictRefreshSize = true
  private _offset: number
  maxOutstreamWidth = 300
  ibvConfig = new IBVConfig(this)

  constructor(slotModel: ISlotModel, model: WebModel) {
    super(slotModel, model)
    this._sizes = this.adSizes
    this.timeout = new Timeout(this, timeouts)

    this.selector =
      Device.isMobileOrTablet && slotModel.mobileSelector
        ? slotModel.mobileSelector
        : slotModel.selector

    this.insertPosition =
      Device.isMobileOrTablet && slotModel.mobileInsertPosition
        ? (slotModel.mobileInsertPosition as InsertPosition)
        : (slotModel.insertPosition as InsertPosition)

    this.adUnitId = Device.isMobileOrTablet
      ? MOBILE_ADUNIT_ID
      : DESKTOP_ADUNIT_ID

    const offsetMultiplier = parseFloat(
      model.experiment.activate<string>(ExperimentFlag.recipeOffset) ||
        '1.00001'
    )
    this._offset = WindowSize.height * offsetMultiplier
    this.setTargeting({ offsetMultiplier })
  }

  get offset() {
    return this._offset
  }
  get id(): string {
    if (this.number === 1) {
      return this.adUnitId
    } else {
      return this.adUnitId.replace('_', `_${this.number}_`)
    }
  }

  meetsOutstreamCriteria(): boolean {
    const recipeDensityMap = {
      off: Infinity,
      light: 2,
      medium: 1,
      high: 1
    }

    const densitySetting = this.model.outstream_density
    const densityNumber = recipeDensityMap[densitySetting] || 1

    const number = this.number

    return (number + 1) % densityNumber === 0
  }

  template(): string {
    const template = super.template()

    return Device.isMobileOrTablet
      ? `
        <div class='remove_padding'>
          ${template}
        </div>
      `
      : template
  }

  sizeContainersLogic(): void {
    super.sizeContainersLogic()
    if (this.adType === AdType.inBannerNative) {
      this.wrapper.style.width = '300px'
    }
  }

  private get adSizes(): AdSizes {
    const sizes = [
      [300, 250],
      [300, 200],
      [468, 60]
    ] as AdSizes

    if (Device.isMobile) {
      sizes.push([320, 50], [300, 50], [320, 100])
    } else {
      sizes.push([250, 250])
    }

    return sizes
  }
}
